import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function InvitePage({ onLogin }) {
  const [status, setStatus] = useState('loading'); // loading | error
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (!token) {
      setStatus('error');
      setErrorMsg('No invite token found in this link.');
      return;
    }
    validateInvite(token);
  }, []);

  const validateInvite = async (token) => {
    try {
      const res = await axios.post(`${API}/auth/validate-invite`, { token });
      const { token: sessionToken, user } = res.data;
      // Clean URL before handing off
      window.history.replaceState({}, '', '/');
      onLogin(sessionToken, user, true); // true = isInvite
    } catch (error) {
      setStatus('error');
      setErrorMsg(error.response?.data?.detail || 'Invalid or expired invite link.');
    }
  };

  if (status === 'loading') {
    return (
      <div className="min-h-screen bg-[#09090B] flex flex-col items-center justify-center gap-4 px-6">
        <div className="w-12 h-12 border-4 border-[#CCFF00] border-t-transparent rounded-full animate-spin" />
        <p className="text-[#CCFF00] text-xl font-heading font-black uppercase tracking-widest">
          Setting up your account...
        </p>
        <p className="text-[#A1A1AA] text-sm">Please wait a moment</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#09090B] flex flex-col items-center justify-center gap-6 px-6">
      <div className="bg-[#18181B] border border-[#EF4444]/40 rounded-sm p-8 max-w-sm w-full text-center space-y-4">
        <div className="w-14 h-14 bg-[#EF4444]/10 rounded-full flex items-center justify-center mx-auto">
          <svg className="w-7 h-7 text-[#EF4444]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <h2 className="text-2xl font-heading font-black uppercase text-[#FAFAFA] tracking-tight">
          Invalid Link
        </h2>
        <p className="text-[#A1A1AA] text-sm leading-relaxed">{errorMsg}</p>
        <a
          href="/"
          className="block mt-2 bg-[#CCFF00] text-black font-bold uppercase tracking-wider rounded-sm py-3 px-6 hover:bg-[#B3E600] transition-colors text-sm"
        >
          Go to Login
        </a>
      </div>
    </div>
  );
}
